import { Autocomplete, TextField } from "@mui/material";
import axios from "axios";
import { endpoints } from "../../../../../../endpoints/endpoints";
import SearchUserProps from "../interface/searchUserProps";
import React from "react";
import { User, AppContext } from "../../../../../../context/appContext";
import NewCoachProps from "../interface/newCoachProps";
import SelectedParticipantProps from "../interface/selectedParticipantProps";

interface SelectCoachOption {
  label: string;
  participantId: number;
}

const RenderSearchInput = ({
  searchUser,
  setSearchUser,
  newCoach,
  setNewCoach,
}: {
  searchUser: SearchUserProps;
  setSearchUser: React.Dispatch<React.SetStateAction<SearchUserProps>>;
  newCoach: NewCoachProps;
  setNewCoach: React.Dispatch<React.SetStateAction<NewCoachProps>>;
}): React.JSX.Element => {
  const {
    user,
    checkSession,
  }: {
    user: User;
    checkSession: (response: any) => void;
  } = React.useContext(AppContext);

  const startSearch = (participantName: string): void => {
    setSearchUser({
      ...searchUser,
      loading: true,
    });

    axios
      .post(endpoints.admin.searchParticipant, {
        sessionId: user.sessionId,
        searchString: participantName,
      })
      .then((response) => {
        checkSession(response);

        const sortetUser = response.data.data.map(
          (user: SelectedParticipantProps) => {
            return {
              label: `${user.firstName} ${user.lastName} (${user.email})`,
              participantId: user.participantId,
            };
          }
        );

        setSearchUser({
          ...searchUser,
          loading: false,
          searchResults: sortetUser,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <Autocomplete
      fullWidth
      loading={searchUser.loading}
      loadingText="Suche..."
      disablePortal
      noOptionsText="Bitte mindestens 2 Zeichen eingeben."
      id="seqarchParticipantInput"
      options={searchUser.searchResults}
      value={searchUser.selectedParticipant}
      isOptionEqualToValue={(option: SelectCoachOption, value) =>
        option.participantId === value.participantId
      }
      onInput={(event: any) => {
        setSearchUser({
          ...searchUser,
          searchString: event.target.value,
        });

        if (searchUser.loading) return;
        if (event.target.value.length < 2) return;
        startSearch(event.target.value);
      }}
      onChange={(_event, option: SelectCoachOption) => {
        setSearchUser({
          ...searchUser,
          selectedParticipant: searchUser.searchResults.find(
            (user: SelectedParticipantProps) =>
              user.participantId === option?.participantId
          ),
        });

        setNewCoach({
          ...newCoach,
          firstName: option ? option.label.split(" ")[0] : "",
          lastName: option ? option.label.split(" ")[1] : "",
          email: option
            ? option.label.split(" ")[2].replace("(", "").replace(")", "")
            : "",
        });
      }}
      renderInput={(params) => (
        <TextField
          error={
            searchUser.searchString.length < 2 &&
            !searchUser.selectedParticipant
          }
          helperText={
            searchUser.searchString.length < 2 &&
            !searchUser.selectedParticipant
              ? "Bitte mindestens 2 Zeichen eingeben"
              : ""
          }
          color="success"
          {...params}
          label="User:in"
        />
      )}
    />
  );
};

export default RenderSearchInput;
